<template>
  <transition name="bbe-bounce">
    <div class="bbe-text-editor" :class="{'bbe-text-editor__shadow': shadow}">
      <button class="bbe-text-editor-item" v-if="selectDown">
          <span class="bbe-text-editor-item__icon bbe-text-editor-item__icon_font-family"
                :class="{'bbe-text-editor-item__icon_active': fontFamilyOpen}"
                @click.stop="fontFamilyOpen = !fontFamilyOpen">
           <transition name="bbe-bounce" mode="in-out">
              <FontFamilySelect
                class="bbe-text-editor-item__select bbe-text-editor-item__select_font-family"
                :class="{'bbe-text-editor-item__select_down': selectDown}"
                v-if="fontFamilyOpen"
                @set="setFontFamily"
                @close="closeFormatOptions('fontFamilyOpen')"/>
           </transition>
            {{getActiveFontFamily()}}
            <i class="email-icon-arrow bbe-text-editor-item__arrow"
               :class="{'bbe-text-editor-item__arrow_open': fontFamilyOpen}"/>
          </span>
      </button>
      <button class="bbe-text-editor-item">
          <span class="bbe-text-editor-item__icon bbe-text-editor-item__icon_font-size"
                :class="{'bbe-text-editor-item__icon_active': fontSizeOpen}"
                @click.stop="fontSizeOpen = !fontSizeOpen">
           <transition name="bbe-bounce">
              <FontSizeSelect
                class="bbe-text-editor-item__select"
                :class="{'bbe-text-editor-item__select_down': selectDown}"
                v-if="fontSizeOpen"
                @set="setFontSize"
                @close="closeFormatOptions('fontSizeOpen')"/>
           </transition>
            {{getActiveFontSize()}}
            <i class="email-icon-arrow bbe-text-editor-item__arrow"
               :class="{'bbe-text-editor-item__arrow_open': fontSizeOpen}"/>
          </span>
      </button>
      <button class="bbe-text-editor-item">
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('bold')}"
                type="button"
                @click="setFont('bold')">
          <i class="email-icon-bold"/>
        </button>
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('italic')}"
                type="button"
                @click="setFont('italic')">
          <i class="email-icon-italic"/>
        </button>
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('underline')}"
                type="button"
                @click="setFont('underline')">
          <i class="email-icon-underline"/>
        </button>
      </button>
      <button class="bbe-text-editor-item">
          <span class="bbe-text-editor-item__icon bbe-text-editor-item__icon_color-palette"
                :class="{'bbe-text-editor-item__icon_active': colorTextOpen}"
                @click.stop="colorTextOpen = !colorTextOpen">
            <transition name="bbe-bounce">
              <ColorPalette class="bbe-text-editor-item__select"
                            :class="{'bbe-text-editor-item__select_down': selectDown}"
                            v-if="colorTextOpen"
                            :activeColor="getFormatting('color')"
                            @close="closeFormatOptions('colorTextOpen')"
                            @set="setColorText"/>
            </transition>
            <i class="email-icon-text-colour"/>
            <i class="email-icon-arrow bbe-text-editor-item__arrow bbe-text-editor-item__arrow_color-palette"
                :class="{'bbe-text-editor-item__arrow_open': colorTextOpen}"/>
          </span>
      </button>
      <button class="bbe-text-editor-item">
          <span class="bbe-text-editor-item__icon bbe-text-editor-item__icon_color-palette"
                :class="{'bbe-text-editor-item__icon_active': colorBackgroundOpen}"
                @click.stop="colorBackgroundOpen = !colorBackgroundOpen">
            <transition name="bbe-bounce">
              <ColorPalette class="bbe-text-editor-item__select"
                            :class="{'bbe-text-editor-item__select_down': selectDown}"
                            v-if="colorBackgroundOpen"
                            :activeColor="getFormatting('backgroundColor')"
                            @close="closeFormatOptions('colorBackgroundOpen')"
                            @set="setColorBackground"/>
            </transition>
            <i class="email-icon-highlighter"/>
            <i class="email-icon-arrow bbe-text-editor-item__arrow bbe-text-editor-item__arrow_color-palette"
               :class="{'bbe-text-editor-item__arrow_open': colorBackgroundOpen}"/>
          </span>
      </button>
      <button class="bbe-text-editor-item">
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('unordered')}"
                value="bullet"
                @click="setList('unordered')">
          <i class="email-icon-unordered-list"
             :class="['bbe-text-editor-item__icon_list']"/>
        </button>
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('ordered')}"
                value="ordered"
                @click="setList('ordered')">
          <i class="email-icon-ordered-list"
             :class="['bbe-text-editor-item__icon_list']"/>
        </button>
      </button>
      <div class="bbe-text-editor-item">
        <span class="bbe-text-editor-item__icon"
              :class="{'bbe-text-editor-item__icon_active': getFormatting('link')}"
              @click.stop="openModalInsetLink">
          <i class="email-icon-link"/>
          <transition name="bbe-bounce">
            <InsetLink class="bbe-text-editor-item__select"
                       :class="{'bbe-text-editor-item__select_down': selectDown}"
                       v-if="insetLinkOpen"
                       @insetLink="setLink"
                       @close="insetLinkOpen = false"/>
          </transition>
        </span>
      </div>
      <button class="bbe-text-editor-item">
        <span class="bbe-text-editor-item__icon"
              :class="{'bbe-text-editor-item__icon_active': getFormatting('table') || insetTableOpen}"
              @click.stop="openModalInsetTable">
          <i class="email-icon-table"/>
          <transition name="bbe-bounce">
            <InsetTable class="bbe-text-editor-item__select"
                       :class="{'bbe-text-editor-item__select_down': selectDown}"
                       v-if="insetTableOpen"
                       @insetTable="insetTable"
                       @close="insetTableOpen = false"/>
          </transition>
        </span>
      </button>
      <button class="bbe-text-editor-item">
        <label for="uploadImg" class="bbe-text-editor-item__icon bbe-text-editor-item-upload">
          <i class="email-icon-picture bbe-text-editor-item-upload__icon"/>
          <input class="bbe-text-editor-item-upload__input"
                 type="file"
                 id="uploadImg"
                 name="uploadImg"
                 accept="image"
                 @change="getFileInput">
        </label>
      </button>
      <button class="bbe-text-editor-item">
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('textAlign') === 'left'}"
                value="bullet"
                @click="alignText('justifyLeft')">
          <i class="email-icon-align-left"/>
        </button>
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('textAlign') === 'center'}"
                value="ordered"
                @click="alignText('justifyCenter')">
          <i class="email-icon-align-center"/>
        </button>
        <button class="bbe-text-editor-item__icon"
                :class="{'bbe-text-editor-item__icon_active': getFormatting('textAlign') === 'right'}"
                value="ordered"
                @click="alignText('justifyRight')">
          <i class="email-icon-align-right"/>
        </button>
      </button>
      <button class="bbe-text-editor-item">
          <span class="bbe-text-editor-item__icon bbe-text-editor-item__icon_line-height"
                :class="{'bbe-text-editor-item__icon_active': lineHeightOpen}"
                @click.stop="lineHeightOpen = !lineHeightOpen">
           <transition name="bbe-bounce">
              <LineHeightSelect
                class="bbe-text-editor-item__select"
                :class="{'bbe-text-editor-item__select_down': selectDown}"
                v-if="lineHeightOpen"
                @set="setLineHeight"
                @close="lineHeightOpen = false"/>
           </transition>
            <i class="email-icon-line-height"/>
          </span>
      </button>
    </div>
  </transition>
</template>

<script>
import FontSizeSelect from '@/components/Main/TextEditor/FontSizeSelect/FontSizeSelect'
import ColorPalette from '@/components/Main/TextEditor/ColorPalette/ColorPalette'
import LineHeightSelect from '@/components/Main/TextEditor/LineHeightSelect/LineHeightSelect'
import InsetLink from '@/components/Main/TextEditor/InsetLink/InsetLink'
import InsetTable from '@/components/Main/TextEditor/InsetTable/InsetTable'
import UploadApi from '@/api/Upload/api'
import FontFamilySelect from '@/components/Main/TextEditor/FontFamilySelect/FontFamilySelect'
import fontFamilies from '@/constants/toolbarEditorOptions/fontFamilies'
import {find, get, set} from 'lodash'

export default {
  name: 'ToolbarTextEditor',
  props: ['quill', 'shadow', 'selectDown', 'formatting'],
  components: {
    FontFamilySelect,
    InsetTable,
    InsetLink,
    LineHeightSelect,
    FontSizeSelect,
    ColorPalette
  },
  data () {
    return {
      fontFamily: 'Tahoma',
      fontSize: 14,
      lineHeight: 1,
      lastSelection: [],
      uploadFiles: [],
      colorTextOpen: false,
      colorBackgroundOpen: false,
      fontSizeOpen: false,
      fontFamilyOpen: false,
      lineHeightOpen: false,
      insetLinkOpen: false,
      insetTableOpen: false
    }
  },
  methods: {
    forEachChild (node, valueStyle, typeStyle) {
      if (node.hasChildNodes) {
        node.childNodes.forEach(item => {
          this.forEachChild(item, valueStyle, typeStyle)
        })
      }
      if (!node) return
      if (node.style) {
        node.style[typeStyle] = valueStyle
      }
    },
    replaceStyles (regex, style, valueStyle, typeStyle) {
      let value
      this.quill.selection.eachSelection((e) => { value = e.innerHTML })
      if (!regex.test(value)) return
      this.quill.selection.eachSelection((node) => {
        this.forEachChild(node, valueStyle, typeStyle)
      })
    },
    getFormatting (props) {
      return get(this.formatting, props, false)
    },
    getFileInput (e) {
      const file = e.target.files[0]
      this.setBase64(file)
    },
    setBase64 (file) {
      const img = document.createElement('img')
      img.setAttribute('width', '30%')
      this.uploadFile(file, img)
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        img.src = reader.result
        this.quill.selection.insertHTML(img)
      }
    },
    uploadFile (file, img) {
      const fileData = new FormData()
      fileData.set('label', file.name)
      fileData.set('file', file)
      fileData.set('fieldname', 'uploadFile')
      UploadApi.uploadFile(fileData)
        .then(resp => {
          this.uploadFiles.push(resp.data.id)
          this.$emit('uploadFile', this.uploadFiles)
          img.src = resp.data.path
          img.id = resp.data.id
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    alignText (position) {
      this.quill.execCommand(position)
    },
    setList (list) {
      const command = list === 'ordered' ? 'insertOrderedList' : 'insertUnorderedList'
      this.quill.execCommand(command)
    },
    setFont (command) {
      this.quill.execCommand(command)
    },
    setColorText (color) {
      this.quill.execCommand('forecolor', true, color)
    },
    setColorBackground (color) {
      this.quill.execCommand('background', true, color)
    },
    setFontSize (size) {
      const style = `font-size: ${size}px;`
      const regex = /font-size:.+?;/gmi
      this.replaceStyles(regex, style, size + 'px', 'fontSize')
      this.quill.execCommand('fontsize', true, size)
      this.fontSize = size
    },
    setFontFamily (font) {
      this.quill.execCommand('fontName', true, font.value)
      this.fontFamily = font.title
      set(this.formatting, 'fontFamily', font.value)
    },
    setLineHeight (coefficient) {
      const lineHeight = coefficient * 100
      this.quill.selection.eachSelection((node) => {
        if (node.style) node.style.lineHeight = lineHeight + '%'
      })
      this.lineHeight = coefficient
    },
    getActiveFontSize () {
      const fontSize = get(this.formatting, 'fontSize')
      if (fontSize) {
        const number = parseInt(fontSize, 10)
        this.fontSize = isNaN(number) || !number ? 16 : number
      }
      return this.fontSize
    },
    getActiveFontFamily () {
      const fontFamily = get(this.formatting, 'fontFamily')
      const font = find(fontFamilies, {value: fontFamily})
      if (font) {
        this.fontFamily = font.title
      }
      return this.fontFamily
    },
    getActiveLineHeight () {
      if (this.formatting.lineHeight) {
        const percent = parseInt(this.formatting.lineHeight, 10)
        return percent / 100
      }
      return this.lineHeight
    },
    closeFormatOptions (target) {
      switch (target) {
      case 'colorTextOpen':
        this.colorTextOpen = false
        break
      case 'colorBackgroundOpen':
        this.colorBackgroundOpen = false
        break
      case 'fontSizeOpen':
        this.fontSizeOpen = false
        break
      case 'fontFamilyOpen':
        this.fontFamilyOpen = false
        break
      }
    },
    openModalInsetLink () {
      this.lastSelection = this.quill.selection.save()[0]
      this.insetLinkOpen = !this.insetLinkOpen
    },
    setLink (link) {
      const node = document.getElementById(this.lastSelection.startId)
      if (node) this.quill.selection.setCursorBefore(node)
      this.quill.selection.insertHTML(link)
      this.quill.selection.removeMarkers()
      this.insetLinkOpen = false
    },
    openModalInsetTable () {
      this.lastSelection = this.quill.selection.save()[0]
      this.insetTableOpen = !this.insetTableOpen
    },
    insetTable (table) {
      const node = document.getElementById(this.lastSelection.startId)
      if (node) this.quill.selection.setCursorBefore(node)
      this.quill.selection.insertHTML(table)
      this.quill.selection.removeMarkers()
      this.insetTableOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-text-editor {
    position: relative;
    right: 0;
    display: inline-flex;
    padding: 7px 0;
    margin-left: 14px;
    background: $color-white;
    border-radius: 5px;
    height: 42px;

    &__shadow {
      margin: auto;
      padding: 7px 7px;
      box-shadow: 0 0 10px rgba($color-accent, 0.15);
    }

    &-item {
      padding: 0 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      border-right: 1px solid $color-gallery;
      cursor: pointer;
      transition: 0.3s;

      &-upload {
        &__input {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }
      }

      &__select {
        position: absolute;
        bottom: 25px;
        right: 0;
        padding: 12px;
        border-radius: 4px;
        background-color: $color-white;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.08);
        z-index: 6;

        &_font-family {
          overflow: hidden;
        }

        &_down {
          top: 25px;
          bottom: auto;
        }
      }

      &__icon {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 28px;
        max-width: 28px;
        color: $color-dusty-gray;
        cursor: pointer;
        border-radius: 4px;
        margin: 0 1px;
        padding:0 5px;

        &:last-child {
          margin-right: 0;
        }

        i {
          &:before {
            margin: 0;
          }
        }

        &_font-family {
          padding: 0 12px;
          justify-content: space-between;
          width: 130px;
          max-width: 140px;
        }

        &_color-palette {
          font-size: 15px;
          max-width: 39px;
          min-width: 39px;
        }

        &_line-height {
          font-size: 15px;
        }

        &_font-size {
          max-width: 37px;
          width: 37px;
          padding: 0;
        }

        &_list {
          font-size: 15px;
        }

        &_active,
        &:hover {
          color: $color-dove-gray;
          background-color: $color-gallery;
        }
      }

      &__arrow {
        font-size: 5px;
        margin-left: 5px;
        transition: .2s;

        &_color-palette {
          margin-left: 5px;
        }

        &_open {
          transform: rotate(180deg);
        }
      }

      &:last-child {
        border-right: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/ToolbarTextEditor/ToolbarTextEditor.vue